import React from 'react';
import styled from '@emotion/styled';
import urcodeLogo from '../assets/icons/URCode_logo_img.png';

export const URCodeFooter: React.FC = () => {
    return (
      <Container>
          <LogoImage src={urcodeLogo} alt="URCODE" />
      </Container>
    );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
  padding-bottom: 24px;
`;

const LogoImage = styled.img`
  width: 100px; 
  height: auto;
  object-fit: contain;
`;
